import type { GroupBase, Props } from "react-select";
import Select from "react-select";

import style from "./dropdown.module.css";
const UI = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  props: Props<Option, IsMulti, Group>
) => {
  const { options, onChange, styles, value } = props;
  return (
    <Select
      classNames={{
        container: () => style.container,
      }}
      options={options}
      onChange={onChange}
      styles={styles}
      value={value}
    />
  );
};

export default UI;
